import { useEffect, useState } from "react";
import api from "@/lib/api";

const STATUSES = ["Applied", "In Review", "Interview", "Offer", "Rejected"];
const statusClass = (s) => ({
  "Applied": "jr-status-applied",
  "In Review": "jr-status-review",
  "Interview": "jr-status-interview",
  "Offer": "jr-status-offer",
  "Rejected": "jr-status-rejected",
}[s] || "jr-status-applied");

export default function Applications() {
  const [apps, setApps] = useState([]);
  const load = () => api.get("/applications").then((r) => setApps(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.patch(`/applications/${id}`, { status });
    load();
  };

  return (
    <div className="space-y-4" data-testid="applications-page">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {STATUSES.map((s) => {
          const n = apps.filter(a => a.status === s).length;
          return (
            <div key={s} className="jr-card text-center" data-testid={`status-count-${s}`}>
              <div className={`jr-pill ${statusClass(s)} mb-2`}>{s}</div>
              <div className="text-2xl font-bold text-white">{n}</div>
            </div>
          );
        })}
      </div>

      <div className="jr-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-zinc-400 text-xs">
            <tr className="text-left">
              <th className="pb-3">Company</th>
              <th className="pb-3">Role</th>
              <th className="pb-3">Applied</th>
              <th className="pb-3">Status</th>
              <th className="pb-3">Notes</th>
            </tr>
          </thead>
          <tbody>
            {apps.map((a) => (
              <tr key={a.application_id} className="border-t border-white/5" data-testid="app-row">
                <td className="py-3 text-white">
                  {a.url ? (
                    <a href={a.url} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 underline decoration-white/20" data-testid="app-job-link">
                      {a.company}
                    </a>
                  ) : a.company}
                </td>
                <td className="text-zinc-300">{a.job_title}</td>
                <td className="text-zinc-400">{(a.applied_at || "").slice(0, 10)}</td>
                <td>
                  <select
                    value={a.status}
                    onChange={(e) => updateStatus(a.application_id, e.target.value)}
                    className="jr-input py-1 text-xs"
                    data-testid={`status-select-${a.application_id}`}
                  >
                    {STATUSES.map(s => <option key={s} value={s} className="bg-[#161635]">{s}</option>)}
                  </select>
                </td>
                <td className="text-zinc-500 text-xs">{a.notes}</td>
              </tr>
            ))}
            {apps.length === 0 && (
              <tr><td colSpan={5} className="text-center text-zinc-500 py-8">No applications yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
